"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleValidationNewOption = exports.handleFilterOptionCustom = exports.default = exports.components = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _debouncePromise = _interopRequireDefault(require("debounce-promise"));
var _reactSelect = _interopRequireWildcard(require("react-select"));
var _creatable = _interopRequireDefault(require("react-select/creatable"));
var _asyncCreatable = _interopRequireDefault(require("react-select/async-creatable"));
var _async = _interopRequireDefault(require("react-select/async"));
var _style = _interopRequireDefault(require("./style.scss"));
var _selectLargeList = _interopRequireDefault(require("./selectLargeList"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var classKey = 'select-custom-wrapper';
var CLASS_NAME = _style.default[classKey] || classKey;
var handleValidationNewOption = function handleValidationNewOption(inputValue, selectValue, selectOptions) {
  // Check for the same value
  var exactValueExists = selectOptions.find(function (el) {
    return el.value === inputValue;
  });
  // Check if the value has a valid length.
  // Without this, it will show create option for empty values.
  var valueIsNotEmpty = inputValue.trim().length;
  return !exactValueExists && valueIsNotEmpty;
};
exports.handleValidationNewOption = handleValidationNewOption;
var handleFilterOptionCustom = function handleFilterOptionCustom(option, searchText) {
  return option.data.label.includes(searchText);
};
exports.handleFilterOptionCustom = handleFilterOptionCustom;
var ControlStyles = function ControlStyles(base, state) {
  return _objectSpread(_objectSpread({}, base), {}, {
    minHeight: 'unset',
    backgroundColor: state.isDisabled ? 'transparent' : base.backgroundColor
  });
};
var IndicatorSeparatorStyles = function IndicatorSeparatorStyles(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    display: 'none'
  });
};
var ValueContainerStyles = function ValueContainerStyles(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    minHeight: 30,
    position: 'unset'
  });
};
var SingleValueStyles = function SingleValueStyles(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    color: '#555'
  });
};
var InputStyles = function InputStyles(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    height: 30,
    minHeight: 'unset',
    margin: 'unset',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex'
  });
};
var DownChevronStyles = function DownChevronStyles(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    display: 'none'
  });
};
var GroupStyles = function GroupStyles(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    paddingTop: '8px',
    paddingBottom: '8px'
  });
};
var OptionStyles = function OptionStyles(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    padding: '6px 16px'
  });
};
var IndicatorsContainerStyles = function IndicatorsContainerStyles(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    color: '#4a4a4a',
    height: 30,
    minHeight: 'unset',
    position: 'unset'
  });
};
var ClearIndicatorStyles = function ClearIndicatorStyles(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    height: 30,
    width: 30,
    minHeight: 'unset',
    position: 'unset'
  });
};
var PlaceholderStyles = function PlaceholderStyles(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    color: 'rgb(128, 128, 128)'
  });
};
var OriginalStyles = function OriginalStyles(props) {
  return _objectSpread({}, props);
};
var Select = function Select(props) {
  var async = props.async,
    cacheOptions = props.cacheOptions,
    defaultOptions = props.defaultOptions,
    loadOptions = props.loadOptions,
    waitTime = props.waitTime,
    value = props.value,
    options = props.options,
    disabled = props.disabled,
    onChange = props.onChange,
    clearable = props.clearable,
    searchable = props.searchable,
    placeholder = props.placeholder,
    multi = props.multi,
    name = props.name,
    removeSelected = props.removeSelected,
    closeOnSelect = props.closeOnSelect,
    onBlurResetsInput = props.onBlurResetsInput,
    onCloseResetsInput = props.onCloseResetsInput,
    onSelectResetsInput = props.onSelectResetsInput,
    reactSelectRef = props.reactSelectRef,
    onInputChange = props.onInputChange,
    filterOption = props.filterOption,
    validNewOption = props.validNewOption,
    isCaseSensitive = props.isCaseSensitive,
    onOpen = props.onOpen,
    onClose = props.onClose,
    groupOptions = props.groupOptions,
    isDisplayFullMenu = props.isDisplayFullMenu,
    isDisplayLargeList = props.isDisplayLargeList,
    ReactComponents = props.ReactComponents,
    _noOptionsMessage = props.noOptionsMessage,
    onChangeHandler = props.onChangeHandler,
    input = props.input,
    inputValue = props.inputValue,
    creatable = props.creatable,
    customCreateLabel = props.customCreateLabel,
    createOptionPosition = props.createOptionPosition,
    onBlur = props.onBlur,
    onDragStart = props.onDragStart,
    onDrop = props.onDrop,
    onFocus = props.onFocus,
    menuPortalTarget = props.menuPortalTarget,
    meta = props.meta,
    onMenuOpen = props.onMenuOpen,
    formatOptionLabel = props.formatOptionLabel,
    inputMaxLength = props.inputMaxLength,
    customStyles = props.customStyles,
    menuPlacement = props.menuPlacement,
    multiValue = props.multiValue,
    multiValueLabel = props.multiValueLabel,
    multiValueRemove = props.multiValueRemove,
    t = props.t;
  var _useState = (0, _react.useState)(value ? value.label : ''),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    currentInputValue = _useState2[0],
    setCurrentInputValue = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    finalValueToUse = _useState4[0],
    setFinalValueToUse = _useState4[1];
  var valueChk = value || input.value;
  if (!groupOptions && !multi && valueChk && valueChk.constructor === Array) {
    var temp = valueChk[0];
    valueChk = temp;
  }
  var flossedOptions = options && options.filter(function (option) {
    return option && (option.value || option.value === 0);
  });
  var flossedGroupOptions = groupOptions && groupOptions.filter(function (option) {
    return option;
  });
  var selectValue = function () {
    if (async && !creatable || multi) {
      return valueChk;
    }
    return flossedOptions.find(function (element) {
      return element.value === (valueChk && valueChk.value) || element.value === valueChk;
    });
  }();
  var groupSelectValue = flossedGroupOptions && (!options || !options.length > 0) ? valueChk : null;
  (0, _react.useEffect)(function () {
    if (value || input.value) {
      var finalValue = selectValue || groupSelectValue;
      setFinalValueToUse(finalValue);
    }
    if (!value && !input.value && finalValueToUse) {
      setFinalValueToUse(null);
    }
  }, [value, input.value]);
  (0, _react.useEffect)(function () {
    if (multi && searchable && value && value.constructor === Object) {
      setCurrentInputValue(value.label);
    } else if (multi && searchable && value && value.constructor === String) {
      setCurrentInputValue(value);
    } else if (multi && searchable) {
      setCurrentInputValue('');
    }
  }, [value, searchable, multi]);
  var formInputValue = input && flossedOptions && flossedOptions.find(function (option) {
    return option && option.value === valueChk;
  });
  var fullMenuHeight = isDisplayFullMenu && options.length > 1 ? options.length * 36 + 8 : undefined;
  var valueToUse = formInputValue || groupSelectValue || selectValue || finalValueToUse || '';
  if (creatable && !multi) {
    if (valueChk) {
      valueToUse = valueChk.constructor === Object ? valueChk : {
        value: valueChk,
        label: valueChk
      };
    }
  }
  var handleInputChange = function handleInputChange(newValue, e) {
    if (e.action === 'input-change') {
      var valueToSet = newValue;
      if (inputMaxLength && valueToSet && valueToSet.length > inputMaxLength) {
        valueToSet = valueToSet.substr(0, inputMaxLength);
      }
      setCurrentInputValue(valueToSet);
      onInputChange(valueToSet);
    }
  };
  var handleBlur = function handleBlur() {
    // Reset input value if it is not selected
    // Handle for seachable of select and create new value select.
    if (searchable && !multi) {
      if (!finalValueToUse && !valueToUse || !currentInputValue) {
        setCurrentInputValue('');
      } else {
        var inputVal = finalValueToUse || valueToUse;
        if (inputVal.constructor === Object) {
          setCurrentInputValue(inputVal.label);
        } else if (creatable) {
          setCurrentInputValue(inputVal);
        } else {
          setCurrentInputValue('');
        }
      }
    }
    if (onBlur) {
      onBlur();
    } else if (input && input.onBlur) {
      input.onBlur();
    }
  };
  var onFormatCreateLabel = function onFormatCreateLabel(newValue) {
    if (!newValue.trim()) {
      setCurrentInputValue('');
    } else if (multi) {
      if (valueToUse) {
        valueToUse = valueToUse.constructor === Array ? [].concat((0, _toConsumableArray2.default)(valueToUse), [{
          value: newValue,
          label: newValue
        }]) : [valueToUse, {
          value: newValue,
          label: newValue
        }];
      } else {
        valueToUse = [{
          value: newValue,
          label: newValue
        }];
      }
      if (input && input.onChange) {
        onChangeHandler(valueToUse);
        input.onChange(valueToUse);
      } else {
        onChange(valueToUse);
      }
    } else {
      valueToUse = newValue.constructor === Object ? newValue : {
        value: newValue,
        label: newValue
      };
      setCurrentInputValue('');
      if (input && input.onChange) {
        onChangeHandler(valueToUse.value);
        input.onChange(valueToUse.value);
      } else {
        onChange(valueToUse.value);
      }
    }
    setFinalValueToUse(valueToUse);
    setCurrentInputValue('');
  };
  var onSelectValue = function onSelectValue(selectedValue) {
    setCurrentInputValue('');
    if (creatable && !multi) {
      if (input && input.onChange) {
        onChangeHandler(selectedValue && selectedValue.label);
        input.onChange(selectedValue && selectedValue.label);
      } else {
        onChange(selectedValue && selectedValue.label);
      }
      valueToUse = selectedValue;
      setFinalValueToUse(valueToUse);
    } else if (input && input.onChange) {
      if (multi || groupOptions) {
        onChangeHandler(selectedValue);
        input.onChange(selectedValue);
        valueToUse = selectedValue;
        setFinalValueToUse(valueToUse);
      } else {
        onChangeHandler(selectedValue && selectedValue.value);
        input.onChange(selectedValue && selectedValue.value);
        valueToUse = selectedValue;
        setFinalValueToUse(valueToUse);
      }
    } else {
      onChange(selectedValue);
      valueToUse = selectedValue;
      setFinalValueToUse(valueToUse);
    }
  };
  var SelectedComponent = _reactSelect.default;
  if (creatable) {
    SelectedComponent = _creatable.default;
  }
  if (async) {
    SelectedComponent = _async.default;
  }
  if (async && creatable) {
    SelectedComponent = _asyncCreatable.default;
  }
  // handle props for input value
  var inputProps = async ? {} : {
    onInputChange: handleInputChange,
    inputValue: searchable ? currentInputValue : ''
  };
  var filterOptionCustom = isCaseSensitive ? handleFilterOptionCustom : filterOption;
  var isValidNewOption = isCaseSensitive ? handleValidationNewOption : validNewOption;
  var commonProps = {
    styles: {
      control: ControlStyles,
      indicatorSeparator: IndicatorSeparatorStyles,
      valueContainer: ValueContainerStyles,
      singleValue: SingleValueStyles,
      input: InputStyles,
      DownChevron: DownChevronStyles,
      Group: GroupStyles,
      Option: OptionStyles,
      indicatorsContainer: IndicatorsContainerStyles,
      clearIndicator: ClearIndicatorStyles,
      placeholder: PlaceholderStyles,
      menu: customStyles.menuStyles || OriginalStyles,
      menuList: customStyles.menuListStyles || OriginalStyles,
      menuPortal: customStyles.menuPortalStyles || OriginalStyles,
      option: customStyles.optionStyles || OriginalStyles,
      multiValue: multiValue || OriginalStyles,
      multiValueLabel: multiValueLabel || OriginalStyles,
      multiValueRemove: multiValueRemove || OriginalStyles
    },
    cacheOptions: cacheOptions,
    className: "react-select-container ".concat(props.className.includes('middle-align') ? 'middle-align' : ''),
    classNamePrefix: 'react-select',
    closeMenuOnSelect: closeOnSelect,
    components: ReactComponents,
    createOptionPosition: createOptionPosition,
    defaultOptions: defaultOptions,
    filterOption: filterOptionCustom,
    formatCreateLabel: function formatCreateLabel(LabelValue) {
      return "".concat(customCreateLabel, " \"").concat(LabelValue, "\"");
    },
    formatOptionLabel: formatOptionLabel,
    hideSelectedOptions: removeSelected,
    isClearable: clearable,
    isDisabled: disabled,
    isMulti: multi,
    isSearchable: searchable,
    isValidNewOption: isValidNewOption,
    maxMenuHeight: isDisplayFullMenu ? fullMenuHeight : undefined,
    menuPlacement: menuPlacement || 'auto',
    menuPortalTarget: menuPortalTarget || null,
    minMenuHeight: isDisplayFullMenu ? fullMenuHeight : undefined,
    name: name,
    noOptionsMessage: function noOptionsMessage() {
      return t(_noOptionsMessage);
    },
    onBlur: handleBlur,
    onBlurResetsInput: onBlurResetsInput,
    onChange: onSelectValue,
    onClose: onClose,
    onCloseResetsInput: onCloseResetsInput,
    onCreateOption: onFormatCreateLabel,
    onDragStart: onDragStart || input.onDragStart,
    onDrop: onDrop || input.onDrop,
    onFocus: onFocus || input.onFocus,
    onMenuOpen: onMenuOpen,
    onOpen: onOpen,
    onSelectResetsInput: onSelectResetsInput,
    options: flossedGroupOptions || flossedOptions || [],
    placeholder: placeholder,
    ref: reactSelectRef
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-value": value,
    className: "".concat(props.className, " ").concat(CLASS_NAME)
  }, isDisplayLargeList ? /*#__PURE__*/_react.default.createElement(_selectLargeList.default, (0, _extends2.default)({}, commonProps, {
    inputValue: inputValue,
    onInputChange: onInputChange,
    onChangeHandler: onChangeHandler,
    onBlur: onBlur,
    value: meta ? finalValueToUse || valueToUse : value,
    loadOptions: loadOptions ? (0, _debouncePromise.default)(loadOptions, 250) : null
  })) : /*#__PURE__*/_react.default.createElement(SelectedComponent, (0, _extends2.default)({}, inputProps, commonProps, {
    loadOptions: (0, _debouncePromise.default)(loadOptions, waitTime),
    value: finalValueToUse || valueToUse
  })));
};
Select.propTypes = {
  async: _propTypes.default.bool,
  ReactComponents: _propTypes.default.instanceOf(Object),
  cacheOptions: _propTypes.default.bool,
  className: _propTypes.default.string,
  clearable: _propTypes.default.bool,
  closeOnSelect: _propTypes.default.bool,
  creatable: _propTypes.default.bool,
  createOptionPosition: _propTypes.default.string,
  customCreateLabel: _propTypes.default.string,
  /** See: https://react-select.com/async#defaultoptions */
  defaultOptions: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func]),
  disabled: _propTypes.default.bool,
  filterOption: _propTypes.default.func,
  validNewOption: _propTypes.default.func,
  isCaseSensitive: _propTypes.default.bool,
  formatOptionLabel: _propTypes.default.func,
  groupOptions: _propTypes.default.instanceOf(Array),
  inputValue: _propTypes.default.string,
  /** For use with redux-form */
  input: _propTypes.default.shape({
    value: _propTypes.default.number,
    onChange: _propTypes.default.func,
    onBlur: _propTypes.default.func,
    onDragStart: _propTypes.default.func,
    onDrop: _propTypes.default.func,
    onFocus: _propTypes.default.func
  }),
  isDisplayFullMenu: _propTypes.default.bool,
  isDisplayLargeList: _propTypes.default.bool,
  loadOptions: _propTypes.default.func,
  multi: _propTypes.default.bool,
  name: _propTypes.default.string,
  noOptionsMessage: _propTypes.default.string,
  onBlurResetsInput: _propTypes.default.bool,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func,
  /** For use with redux-form */
  onChangeHandler: _propTypes.default.func,
  onClose: _propTypes.default.func,
  onCloseResetsInput: _propTypes.default.bool,
  onDragStart: _propTypes.default.func,
  onDrop: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onInputChange: _propTypes.default.func,
  onOpen: _propTypes.default.func,
  onMenuOpen: _propTypes.default.func,
  onSelectResetsInput: _propTypes.default.bool,
  /** Basic format for options: [ { value, label } ] */
  options: _propTypes.default.instanceOf(Array),
  placeholder: _propTypes.default.string,
  reactSelectRef: _propTypes.default.shape({}),
  removeSelected: _propTypes.default.bool,
  searchable: _propTypes.default.bool,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.shape({})]),
  /** Debouncing wait period */
  waitTime: _propTypes.default.number,
  menuPortalTarget: _propTypes.default.shape({}),
  /** For use with redux-form */
  meta: _propTypes.default.shape({}),
  inputMaxLength: _propTypes.default.number,
  customStyles: _propTypes.default.shape({
    menuStyles: _propTypes.default.func,
    menuListStyles: _propTypes.default.func,
    menuPortalStyles: _propTypes.default.func,
    optionStyles: _propTypes.default.func
  }),
  multiValue: _propTypes.default.func,
  multiValueLabel: _propTypes.default.func,
  multiValueRemove: _propTypes.default.func,
  menuPlacement: _propTypes.default.string,
  t: _propTypes.default.func
};
Select.defaultProps = {
  async: false,
  ReactComponents: null,
  cacheOptions: false,
  className: 'select-custom-wrapper',
  clearable: false,
  closeOnSelect: true,
  creatable: false,
  createOptionPosition: 'first',
  customCreateLabel: 'Create new value',
  defaultOptions: false,
  disabled: false,
  filterOption: undefined,
  validNewOption: undefined,
  isCaseSensitive: false,
  formatOptionLabel: null,
  groupOptions: null,
  inputValue: '',
  input: {
    onBlur: null,
    onDragStart: null,
    onDrop: null,
    onFocus: null
  },
  isDisplayFullMenu: false,
  isDisplayLargeList: false,
  loadOptions: null,
  meta: null,
  multi: false,
  name: '',
  noOptionsMessage: 'No results found',
  onBlurResetsInput: true,
  onBlur: null,
  onChange: function onChange() {
    return null;
  },
  onChangeHandler: function onChangeHandler() {
    return null;
  },
  onClose: null,
  onCloseResetsInput: true,
  onDragStart: null,
  onDrop: null,
  onFocus: null,
  onInputChange: function onInputChange() {
    return null;
  },
  multiValue: null,
  multiValueLabel: null,
  multiValueRemove: null,
  onOpen: null,
  onMenuOpen: null,
  onSelectResetsInput: true,
  options: [],
  placeholder: '',
  reactSelectRef: null,
  removeSelected: false,
  searchable: false,
  value: null,
  waitTime: 2000,
  menuPortalTarget: null,
  inputMaxLength: null,
  customStyles: {
    menuStyles: null,
    menuListStyles: null,
    menuPortalStyles: null,
    optionStyles: null
  },
  menuPlacement: null,
  t: function t(x) {
    return x;
  }
};
var _default = Select;
exports.default = _default;
var components = _reactSelect.components;
exports.components = components;